var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpdVzlaUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 630 70",
    style: {
      enableBackground: "new 0 0 630 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FA9D01;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_65_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2060_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2149_",
    className: "st0",
    d: "M139,17h2v-5h0.9c1.6,0,2.9-0.8,3.6-1.7c0.6-0.7,0.9-1.7,0.9-2.8c0-1.1-0.5-2.2-1.2-2.8 c-0.8-0.7-1.8-1.1-3.4-1.1c-0.9,0-1.7,0.2-2.4,0.3L135.1,5h3.9V17z M141,9.4V5.7c1,0,0.6,0,0.7,0c1.2,0,2,0.6,2,1.7 c0,1.8-1.6,2-2.3,2C141.3,9.4,141,9.4,141,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2148_",
    className: "st0",
    d: "M147,9.5V17h2v-6c0-0.2,0.3-0.5,0.4-0.7c0.1-0.4,0.7-1.4,1.7-1.4h0.9V7h-0.9 c-0.6,0-1.2,0.2-1.7,0.6l0-0.6H147v0.4c0,0.3,0,0.6,0,1C147,8.7,147,9.1,147,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2145_",
    className: "st0",
    d: "M155.3,16.3c1.9,0,3.8-1.5,3.8-4.8c0-3.5-1.9-4.8-3.6-4.8c-1.8,0-3.8,1.3-3.8,4.8 C151.6,15.1,153.5,16.3,155.3,16.3z M154.1,11.5c0-1,0.2-2.8,1.2-2.8c0.9,0,1.1,1.7,1.1,2.8c0,1.3-0.3,2.8-1.1,2.8 C154.2,14.3,154.1,12.4,154.1,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2142_",
    className: "st0",
    d: "M162.8,16.3c0.6,0,1.1-0.1,1.5-0.4c-0.1,1.5-0.8,1.7-1.5,1.7c-0.5,0-1.1-0.1-1.7-0.3 l-0.5-0.2L160,19l0.4,0.2c0.6,0.3,1.4,0.5,2.4,0.5c1.3,0,2.4-0.4,3.1-1c0.8-0.8,1.2-1.8,1.2-4V10c0-0.7,0-1.3,0-1.7 c0-0.3,0-0.6,0-0.8V7h-2.4l0,0.3c-0.4-0.3-0.9-0.5-1.5-0.5c-1.7,0-3.6,1.5-3.6,4.9C159.4,14.4,160.8,16.3,162.8,16.3z M164,12.6 c0,0.2,0.2,0.4,0.1,0.6c-0.2,0.7-0.6,0.8-0.9,0.8c-0.8,0-1.2-1-1.2-2.6c0-1.3,0.4-2.6,1.3-2.6c0.2,0,0.7,0,0.9,0.9l-0.1,0.1 c0,0.1-0.1,0.3-0.1,0.4V12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2141_",
    className: "st0",
    d: "M168,9.5V17h2v-6c0-0.2,0.3-0.5,0.4-0.7c0.1-0.4,0.7-1.4,1.8-1.4h0.8V7h-0.8 c-0.6,0-1.2,0.2-1.7,0.6l0-0.6H168v0.4c0,0.3,0,0.6,0,1C168,8.7,168,9.1,168,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2138_",
    className: "st0",
    d: "M174.4,9.1c0.3-0.2,0.8-0.4,1.4-0.4c0.6,0,1,0.2,1.1,1.2c-2.6,0.2-4.2,1.5-4.2,3.5 c0,1.6,1.2,2.9,2.9,2.9c0.6,0,1.1,0.2,1.6-0.1l0,0.7h2.4l-0.3-1c-0.1-0.6-0.3-1.6-0.3-2.3v-3.6c0-2.3-0.9-3.5-3.1-3.5 c-1,0-1.9,0.3-2.4,0.6l-0.4,0.2l0.8,2L174.4,9.1z M175.8,14.3c-0.2,0-0.6-0.1-0.6-1c0-0.8-0.2-1.3,1.8-1.4v1.2 c0,0.1-0.1,0.2-0.1,0.3C176.7,14,176.3,14.3,175.8,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2137_",
    className: "st0",
    d: "M183,10.3c0-0.3,0.1-0.4,0.2-0.6c0.2-0.6,0.5-1,1-1c0.3,0,0.8,0,0.8,1.4V17h2v-6.7 c0-0.2,0.3-0.4,0.4-0.6c0.2-0.6,0.4-0.9,0.9-0.9c0.6,0,0.8,0.2,0.8,1.7V17h3v-6.8c0-3.1-1.9-3.5-2.8-3.5c-0.4,0-1,0-1.6,0.4 c-0.3,0.2-0.5,0.3-0.7,0.6c-0.5-0.6-1.2-0.9-2.2-0.9c-0.7,0-1.3,0.3-1.9,0.7l0-0.4H180v0.4c0,0.3,0.3,0.6,0.3,0.9 c0,0.2,0.3,0.7,0.3,0.7H180v8h3V10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2134_",
    className: "st0",
    d: "M192.9,13.5c0,1.6,1.2,2.9,2.9,2.9c0.6,0,1.1,0.2,1.6-0.1l0,0.7h2.4l-0.4-1 c-0.1-0.6-0.4-1.6-0.4-2.3v-3.6c0-2.3-0.8-3.5-3-3.5c-1,0-1.8,0.3-2.3,0.6l-0.3,0.2l0.8,2l0.5-0.3c0.3-0.2,0.8-0.4,1.4-0.4 c0.6,0,1,0.2,1.1,1.2C194.6,10.1,192.9,11.4,192.9,13.5z M196.1,14.3c-0.2,0-0.8-0.1-0.8-1c0-0.8,0.7-1.3,1.7-1.4v1.2 c0,0.1,0.1,0.2,0,0.3C196.9,14,196.6,14.3,196.1,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2131_",
    className: "st0",
    d: "M139,33h2v-5h0.9c1.6,0,2.9-0.5,3.6-1.4c0.6-0.7,0.9-1.6,0.9-2.7c0-1.1-0.5-2.2-1.2-2.7 c-0.8-0.7-1.8-1-3.4-1c-0.9,0-1.7,0.4-2.4,0.5l-4.4,1.3h3.9V33z M141,26.1v-3.7c1,0,0.6,0,0.7,0c1.2,0,2,0.6,2,1.7 c0,1.8-1.6,2-2.3,2C141.3,26.1,141,26.1,141,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2128_",
    className: "st0",
    d: "M153,27.6c0-2.6-1.1-4.2-3.1-4.2c-2.3,0-3.7,2-3.7,4.9c0,2.9,1.6,4.7,4.1,4.7 c0.8,0,1.8-0.2,2.4-0.4l0.4-0.2l-0.4-1.9l-0.5,0.2c-0.2,0.1-0.7,0.3-1.4,0.3c-0.7,0-1.7,0-1.8-2h4.2V27.6z M148.8,27 c0.2-1,0.5-1.5,1.1-1.5c0.2,0,0.4,0.1,0.5,0.3c0.2,0.3,0.4,1.2,0.4,1.2H148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2125_",
    className: "st0",
    d: "M161,37V26.6c0-1.2,0.1-1.7,0.2-2.3l0.2-0.3h-2.4l0,0.1c-0.4-0.3-0.9-0.6-1.5-0.6 c-1.8,0-3.6,1.4-3.6,4.8c0,3.2,1.4,4.7,3.1,4.7c0.6,0,1.2-0.2,1.2-0.4V37H161z M156.3,28.2c0-1.3,0.1-2.7,1-2.7 c0.4,0,0.6,0.5,0.6,1.1v2.6c0,0.2,0.3,0.4,0.2,0.6c-0.3,1-0.6,1-0.8,1C156.5,30.9,156.3,29.5,156.3,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2124_",
    className: "st0",
    d: "M162,24v5.3c0,3,1.8,3.7,3.1,3.7c0.7,0,1.4-0.2,1.9-0.5l0.1,0.4h1.8v-0.6 c0-0.3,0.2-0.6,0.2-1c0-0.4-0.1-0.8-0.1-1.3l-0.1-0.5V24h-3v5.6c0,0.2,0.4,0.4,0.3,0.6c0,0.1-0.1,0.7-0.7,0.7 c-0.4,0-0.6-0.1-0.6-1.8V24H162z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2121_",
    className: "st0",
    d: "M177,27.6c0-2.6-1.1-4.2-3.1-4.2c-2.3,0-3.7,2-3.7,4.9c0,2.9,1.6,4.7,4.1,4.7 c0.8,0,1.8-0.2,2.4-0.4l0.4-0.2l-0.4-1.9l-0.5,0.2c-0.2,0.1-0.7,0.3-1.4,0.3c-0.7,0-1.7,0-1.8-2h4.2V27.6z M172.9,27 c0.2-1,0.5-1.5,1.1-1.5c0.2,0,0.4,0.1,0.5,0.3c0.2,0.3,0.4,1.2,0.4,1.2H172.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2120_",
    className: "st0",
    d: "M181.5,25.5c0.3,0,0.5,0,0.5,1.5v6h3v-6.3c0-2.5-1.4-3.4-2.7-3.4c-0.7,0-1.3,0.5-1.9,0.8 l0-0.2H178v0c0,0.3,0.1,0.6,0.1,0.9c0,0.3-0.1,0.7-0.1,1.2l0,0.5V33h3v-6c0-0.3-0.3-0.4-0.2-0.6C180.9,25.8,181,25.5,181.5,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2119_",
    className: "st0",
    d: "M179,24h1.9l0.1-0.8c0-0.1,0.1-0.4,0.1-0.5c0.1,0,0.2,0,0.3,0l-0.1,0 c1.8,0.9,2.8-0.1,2.8-1.8v0h-1.2l-0.1,0.2c0,0.1,0,0,0,0.1c-0.1,0-0.2-0.1-0.4-0.2l-0.2-0.1c-0.3-0.2-0.7-0.4-1.3-0.4 c-1,0-1.8,0.9-1.8,2.1V24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2116_",
    className: "st0",
    d: "M189.6,23.3c-1,0-2,0.3-2.6,0.6l-0.4,0.2l0.7,2l0.5-0.3c0.3-0.2,0.8-0.4,1.4-0.4 c0.6,0,1,0.2,1.1,1.2c-2.6,0.2-4.2,1.5-4.2,3.5c0,1.6,1.2,2.9,2.9,2.9c0.6,0,1.1-0.1,1.6-0.4l0,0.4h2.4l0-0.6 c-0.1-0.6,0-1.3,0-1.9v-3.6C193,24.5,191.8,23.3,189.6,23.3z M189.2,31c-0.2,0-0.8-0.1-0.8-1c0-0.8,0.6-1.3,1.6-1.4v1.2 c0,0.1,0.1,0.2,0.1,0.3C189.9,30.6,189.7,31,189.2,31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2115_",
    className: "st0",
    d: "M199.4,30c0-1.1-0.8-2.1-2.3-3c-1-0.6-1-0.7-1-1c0-0.3,0.3-0.5,0.8-0.5 c0.4,0,0.7,0.1,1.1,0.3l0.5,0.3l0.9-1.9l-0.4-0.2c-0.7-0.3-1.3-0.5-2-0.5c-1.8,0-3.2,1.2-3.2,2.8c0,1.3,1.1,2.1,2.2,2.8 c0.9,0.6,1,0.8,1,1.2c0,0.6-0.7,0.7-1,0.7c-0.5,0-1-0.2-1.3-0.4l-0.5-0.3l-0.6,1.9l0.3,0.2c0.5,0.4,1.4,0.6,2.2,0.6 C198.1,32.9,199.4,31.8,199.4,30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2112_",
    className: "st0",
    d: "M139,49.3l0.5,0.1c0.6,0.2,1.3,0.2,2,0.2c1.8,0,3.2-0.5,4.1-1.4c1.2-1.1,1.8-2.8,1.8-5.3 c0-2.3-0.7-4.1-2.1-5.1c-0.9-0.7-2-1-3.6-1c-0.9,0-1.6,0.1-2.3,0.2l-3.9,1h3.4V49.3z M141,48v-9c0,0,0.5,0,0.6,0 c1.2,0,2.9,0.7,2.9,4.3c0,3-0.8,4.7-2.7,4.7H141z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2109_",
    className: "st0",
    d: "M151.8,40c-1.8,0-3.8,1.3-3.8,4.8c0,3.5,1.9,4.8,3.7,4.8c1.9,0,3.8-1.5,3.8-4.8 C155.4,41.3,153.4,40,151.8,40z M152.8,44.8c0,0.5-0.1,2.8-1.1,2.8c-1.1,0-1.2-1.9-1.2-2.8c0-1.2,0.2-2.7,1.2-2.8 C152.6,42.1,152.8,43.8,152.8,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2108_",
    className: "st0",
    d: "M163,50v-6.6c0-2.5-1.3-3.4-2.7-3.4c-0.7,0-1.3,0.6-1.9,1l0,0H156v-0.3 c0,0.3,0.1,0.6,0.1,0.9c0,0.3-0.1,0.7-0.1,1.2l0,0.5V50h3v-6.3c0-0.3-0.1-0.4,0-0.6c0.2-0.6,0.1-1,0.6-1c0.3,0,0.4,0,0.4,1.5V50 H163z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2105_",
    className: "st0",
    d: "M171,49.2c-0.1-0.6,0-1.4,0-2.1v-3.6c0-2.3-1.2-3.5-3.4-3.5c-1,0-2,0.3-2.6,0.6l-0.4,0.2 l0.7,2l0.5-0.3c0.3-0.2,0.8-0.4,1.4-0.4c0.6,0,1,0.2,1,1.2c-2.6,0.2-4.2,1.5-4.2,3.5c0,1.6,1.2,2.9,2.9,2.9c0.6,0,1.1,0.1,1.6-0.3 l0,0.6h2.4L171,49.2z M167.2,47.7c-0.2,0-0.8-0.1-0.8-1c0-0.8,0.6-1.3,1.6-1.4v1.2c0,0.1,0.1,0.2,0.1,0.3 C167.9,47.3,167.7,47.7,167.2,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2104_",
    className: "st0",
    d: "M176.2,42.1c0.4,0,0.7,0.1,1,0.2l0.5,0.2l0.6-2.1l-0.5-0.1c-0.3-0.1-0.9-0.2-1.5-0.2 c-2.6,0-4.4,2-4.4,4.9c0,2.9,1.6,4.7,4.1,4.7c0.9,0,1.6-0.2,1.8-0.3l0.4-0.2l-0.4-2.1l-0.6,0.2c-0.3,0.1-0.5,0.2-0.9,0.2 c-1.1,0-1.8-1-1.8-2.6C174.4,43.5,174.9,42.1,176.2,42.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2103_",
    x: 178,
    y: 41,
    className: "st0",
    width: 3,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2102_",
    className: "st0",
    d: "M179.6,37.1c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.5-0.6,1.5-1.4 C181.1,37.8,180.6,37.3,179.6,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2099_",
    className: "st0",
    d: "M185.6,49.6c1.9,0,3.8-1.5,3.8-4.8c0-3.5-1.9-4.8-3.6-4.8c-1.8,0-3.8,1.3-3.8,4.8 C181.9,48.4,183.8,49.6,185.6,49.6z M184.4,44.8c0-1.2,0.2-2.7,1.2-2.8c0.9,0,1.1,1.7,1.1,2.8c0,0.5-0.1,2.8-1.1,2.8 C184.6,47.6,184.4,45.7,184.4,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2098_",
    className: "st0",
    d: "M197,50v-6.6c0-2.5-1.3-3.4-2.7-3.4c-0.7,0-1.3,0.6-1.9,1l0,0H190v-0.3 c0,0.3,0.1,0.6,0.1,0.9c0,0.3-0.1,0.7-0.1,1.2l0,0.5V50h3v-6.3c0-0.3-0.1-0.4,0-0.6c0.2-0.6,0.1-1,0.6-1c0.2,0,0.4,0,0.4,1.5V50 H197z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2095_",
    className: "st0",
    d: "M201.9,40.1c-2.3,0-3.7,2-3.7,4.9c0,2.9,1.6,4.7,4.1,4.7c0.8,0,1.8-0.2,2.4-0.4l0.4-0.2 l-0.4-1.9l-0.5,0.2c-0.2,0.1-0.7,0.5-1.4,0.5c-0.7,0-1.7,0.2-1.8-1.8h4.3v-1.7C205,41.8,203.9,40.1,201.9,40.1z M200.8,44 c0.2-1,0.5-1.7,1.1-1.7c0.2,0,0.4,0.2,0.5,0.4c0.2,0.3,0.4,0.3,0.4,1.3H200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2094_",
    className: "st0",
    d: "M209.1,43.7c-1-0.6-1-0.7-1-1c0-0.3,0.3-0.5,0.8-0.5c0.4,0,0.7,0.1,1.1,0.3l0.5,0.3l0.9-1.9 l-0.4-0.2c-0.7-0.3-1.3-0.5-2-0.5c-1.8,0-3.2,1.2-3.2,2.8c0,1.2,0.9,2,2.2,2.8c0.9,0.6,1,0.8,1,1.2c0,0.6-0.7,0.7-1,0.7 c-0.5,0-1-0.2-1.3-0.4l-0.5-0.3l-0.6,1.9l0.3,0.2c0.5,0.4,1.4,0.6,2.2,0.6c2.1,0,3.5-1.1,3.5-2.9 C211.4,45.5,210.7,44.5,209.1,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2091_",
    className: "st0",
    d: "M146,63.7V54h-3v3.1c0-0.2-0.7-0.3-1.2-0.3c-1.7,0-3.4,1.5-3.4,4.9c0,2.9,1.4,4.8,3.4,4.8 c0.7,0,1.3,0.1,1.8-0.2l0,0.8h2.3v-1.3c0-0.3,0-0.6,0-1C146,64.4,146,64,146,63.7z M142.3,64.3c-0.9,0-1.2-1.4-1.2-2.7 c0-0.8,0-2.7,1.1-2.7c0.5,0,0.8,0.5,0.8,1.1v2.8c0,0.1,0.2,0.2,0.1,0.3l0,0.1C143,64.2,142.6,64.3,142.3,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2088_",
    className: "st0",
    d: "M150.7,56.8c-2.3,0-3.8,2-3.8,4.9c0,2.9,1.5,4.7,4.1,4.7c0.8,0,1.8-0.2,2.3-0.4l0.4-0.2 l-0.4-1.9l-0.5,0.2c-0.2,0.1-0.7,0.6-1.4,0.6c-0.7,0-1.7-0.7-1.8-1.7h4.7v-2C154,58.4,152.7,56.8,150.7,56.8z M149.4,61 c0.2-1,0.5-1.8,1.1-1.8c0.2,0,0.4,0.3,0.5,0.5c0.2,0.3,0.4,0.4,0.4,1.4H149.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2087_",
    x: 154,
    y: 54,
    className: "st0",
    width: 3,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2086_",
    className: "st0",
    points: "162,67 164,67 164,61 168,61 168,59 164,59 164,56 168,56 168,54 162,54  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2085_",
    className: "st0",
    d: "M176.9,54l-1.7,5.5c-0.2,0.8-0.4,1.4-0.6,2.1c-0.1-0.3-0.2-0.7-0.3-1 c-0.1-0.4-0.2-0.6-0.4-1.1l-1.7-5.5h-2.5l-0.9,13h2.4l0.3-5.8l0-0.4c0-0.4,0-0.8,0-1.2c0.1,0.2,0.1,0.8,0.2,1l1.9,6.4h1.7l1.8-6.2 c0.1-0.3,0.2-0.8,0.3-1.1c0,0,0,0,0,0c0,0.4,0,1.1,0.1,1.5l0.4,5.8h2.5l-0.9-13H176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2082_",
    className: "st0",
    d: "M183.9,54l-3.4,13h2.5l0.9-4h2.3l0.9,4h2.6l-3.3-13H183.9z M185.7,61h-1.3l0.6-2.6 c0-0.1,0-0.3,0.1-0.4c0,0.1,0.1,0.3,0.1,0.5L185.7,61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2081_",
    className: "st0",
    d: "M197.9,54l-1.7,5.5c-0.2,0.8-0.4,1.4-0.6,2.1c-0.1-0.3-0.2-0.7-0.3-1 c-0.1-0.4-0.2-0.6-0.4-1.1l-1.7-5.5h-2.5l-0.9,13h2.4l0.3-5.8l0-0.4c0-0.4,0-0.8,0-1.2c0.1,0.2,0.1,0.8,0.2,1l1.9,6.4h1.7l1.8-6.2 c0.1-0.3,0.2-0.8,0.3-1.1c0,0,0,0,0,0c0,0.4,0,1.1,0.1,1.5l0.4,5.8h2.5l-0.9-13H197.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2078_",
    className: "st0",
    d: "M61.2,2.5c-5.4,0-10.4,0.4-14.7,1.2L46,3.8V66h8V41.2c2,0.3,4,0.4,5.9,0.4 c7.7,0,14.4-2.5,18.5-7c3.1-3.3,4.7-7.9,4.7-13.5c0-5.4-1.8-10.1-5.2-13.3C74.3,4.3,68.7,2.5,61.2,2.5z M74.6,21.6 c0,3.7-1,6.7-3.2,8.9c-2.4,2.5-6.6,3.8-11.3,3.8c-2.6,0-4.1-0.2-6.1-0.5V10.4c2-0.3,4.3-0.6,6.9-0.6C69.6,9.8,74.6,14,74.6,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2075_",
    className: "st0",
    d: "M20.6,2.5C15.2,2.5,10,2.9,5.7,3.7L5,3.8V66h9V41.2c2,0.3,3.7,0.4,5.7,0.4 c7.7,0,14.3-2.5,18.4-7c3.1-3.3,4.7-7.9,4.7-13.5c0-5.4-1.9-10.1-5.3-13.3C33.8,4.3,28.1,2.5,20.6,2.5z M34.1,21.5 c0,8-5.2,12.6-14.3,12.6c-2.6,0-4.9-0.2-5.9-0.5V10.4c1-0.3,4-0.6,6.7-0.6C29.3,9.8,34.1,14,34.1,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2072_",
    className: "st0",
    d: "M102.6,2.2c-5.4,0-10.9,0.5-16.1,1.4L86,3.7v62l0.6,0.1c4.3,0.5,8.8,0.7,13.7,0.7 c11.2,0,20.5-3.2,26.1-9.1c5.5-6,8.5-14.5,8.5-24.5c0-9.9-2.7-17.3-8.4-22.7C121.2,4.9,113.2,2.2,102.6,2.2z M125.9,33.1 c0,16.7-8.9,25.9-24.5,25.9c-3.2,0-5.4-0.1-7.4-0.3V10.3c2-0.3,4.5-0.7,8.6-0.7c7.3,0,13.2,2,17.1,5.9 C123.8,19.6,126,25.5,125.9,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2071_",
    className: "st0",
    d: "M254.6,32.7l-0.1,0.5c-1.6,6.9-3.5,14.5-4.6,21.9c-1.3-7.1-3.1-14.8-5-22.2L237.5,3h-10.2 l17.3,63.7l0.1,0.3h9.5l17.7-64h-10.2L254.6,32.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2070_",
    className: "st0",
    points: "290,37 308,37 308,30 290,30 290,11 309,11 309,3 280,3 280,67 311,67 311,60  290,60  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2069_",
    className: "st0",
    d: "M351,26c0,10.6,0.5,18.4,1,26.5c-2.5-6.3-5.7-13.4-8.4-19.3L329.6,3H320v64h9V44.7 c0-12.2,0-19.7-0.5-27c2.5,7,5.5,13.3,8,18.7L351,67h9V3h-9V26z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2068_",
    className: "st0",
    points: "383,37 401,37 401,30 383,30 383,11 403,11 403,3 373,3 373,67 404,67 404,60  383,60  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2067_",
    className: "st0",
    points: "411,11 434.9,11 409,62.1 409,67 445,67 445,60 420.5,60 445.2,8.6 445,8.4 445,3  411,3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2066_",
    className: "st0",
    d: "M483,45.7c0,9.9-2.9,14.7-9.6,14.7c-6.5,0-9.4-4.9-9.4-14.7V3h-10v42.5 c0,14.8,6.6,22.3,19.2,22.3c8.9,0,19.8-4,19.8-23.2V3h-10V45.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2065_",
    className: "st0",
    points: "516,37 535,37 535,30 516,30 516,11 536,11 536,3 506,3 506,67 537,67 537,60  516,60  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2064_",
    className: "st0",
    points: "556,3 547,3 547,67 577,67 577,60 556,60  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2061_",
    className: "st0",
    d: "M609.9,3.3L609.8,3h-10.2l-17.4,64h9.3l5-18h15.8l5,18h9.5L609.9,3.3z M604.4,12.9 c0.8,4.1,1.7,9.2,2.7,13.4l3.7,15.7H598l3.7-15.8C602.5,22.7,603.5,17.5,604.4,12.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_68_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_116_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_183_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_195_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2057_",
    className: "st1",
    d: "M137.6,4c0.7-0.1,1.4-0.2,2.3-0.2c1.3,0,2.3,0.2,3,0.9c0.7,0.5,1,1.4,1,2.4 c0,1-0.3,1.8-0.8,2.4c-0.7,0.9-2,1.3-3.3,1.3c-0.3,0-0.4,0-0.7,0v4.7h-1.6L137.6,4L137.6,4z M139.2,9.5c0.1,0,0.4,0.1,0.6,0.1 c1.6,0,2.6-0.9,2.6-2.5c0-1.2-0.6-2.2-2.3-2.2c-0.4,0-0.7,0-0.9,0.1L139.2,9.5L139.2,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2056_",
    className: "st1",
    d: "M145.6,9.2c0-0.7-0.1-1.6-0.1-2.2h1.4l0.1,1.3h0.1c0.3-0.8,1.2-1.5,2.1-1.5 c0.1,0,0.2,0,0.3,0v1.3c-0.1,0-0.2,0-0.3,0c-1,0-1.7,0.7-1.9,1.7c-0.1,0.2-0.1,0.5-0.1,0.7v4.7h-1.6L145.6,9.2L145.6,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2053_",
    className: "st1",
    d: "M156.5,11.2c0,3.2-1.8,4.3-3.3,4.3c-1.8,0-3.2-1.3-3.2-4.3c0-3,1.6-4.3,3.3-4.3 C155.1,6.9,156.5,8.3,156.5,11.2z M151.6,11.2c0,1.4,0.3,3.3,1.7,3.3c1.3,0,1.6-1.9,1.6-3.3c0-1.3-0.3-3.3-1.6-3.3 C151.9,8,151.6,10,151.6,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2050_",
    className: "st1",
    d: "M164.4,14.4c0,2.2-0.3,3-1,3.6c-0.6,0.6-1.6,0.9-2.7,0.9c-0.8,0-1.6-0.1-2.2-0.4l0.4-1 c0.4,0.1,1,0.4,1.9,0.4c1.3,0,2-0.7,2-2.5v-0.8h-0.1c-0.4,0.7-1,1-1.9,1c-1.8,0-2.9-1.7-2.9-4.2c0-3,1.6-4.4,3.1-4.4 c1,0,1.6,0.6,1.9,1.1h0.1l0.1-1h1.4c0,0.6-0.1,1.3-0.1,2.6L164.4,14.4L164.4,14.4z M162.8,9.9c0-0.2,0-0.4-0.1-0.6 c-0.1-0.6-0.5-1.3-1.4-1.3c-1.1,0-1.8,1.3-1.8,3.1c0,2.2,0.8,3.1,1.8,3.1c0.4,0,1.1-0.2,1.4-1.2c0.1-0.2,0.1-0.5,0.1-0.7V9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2049_",
    className: "st1",
    d: "M166.6,9.2c0-0.7-0.1-1.6-0.1-2.2h1.4l0.1,1.3h0.1c0.3-0.8,1.2-1.5,2.1-1.5 c0.1,0,0.2,0,0.3,0v1.3c-0.1,0-0.2,0-0.3,0c-1,0-1.7,0.7-1.9,1.7c-0.1,0.2-0.1,0.5-0.1,0.7v4.7h-1.6L166.6,9.2L166.6,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2046_",
    className: "st1",
    d: "M176.9,13.5c0,0.7,0,1.3,0.1,1.9h-1.4l-0.1-0.9h-0.1c-0.4,0.7-1.1,1-1.9,1 c-1.3,0-2.4-1-2.4-2.4c0-2.1,2-3,4.2-3V9.9c0-1.1-0.3-1.9-1.6-1.9c-0.6,0-1.2,0.1-1.6,0.4l-0.4-1c0.4-0.2,1.3-0.5,2.3-0.5 c2,0,2.8,1.1,2.8,3L176.9,13.5L176.9,13.5z M175.4,11.1c-0.8,0-2.7,0.1-2.7,1.9c0,1.1,0.7,1.5,1.2,1.5c0.7,0,1.3-0.4,1.5-1.3 c0.1-0.1,0.1-0.3,0.1-0.4V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2045_",
    className: "st1",
    d: "M179.2,9.2c0-1-0.1-1.5-0.1-2.2h1.3l0.1,1h0.1c0.4-0.7,1.2-1.2,2.2-1.2 c0.9,0,1.7,0.4,2.1,1.3h0.1c0.3-0.4,0.6-0.7,1-1c0.4-0.2,0.9-0.3,1.3-0.3c1.3,0,2.4,0.8,2.4,3v5.5h-1.6v-5.2 c0-1.1-0.1-2.2-1.4-2.2c-0.7,0-1.3,0.4-1.5,1.3c-0.1,0.2-0.1,0.5-0.1,0.7v5.3h-1.6V9.9c0-1-0.2-1.9-1.3-1.9 c-0.7,0-1.3,0.4-1.5,1.3c-0.1,0.2-0.1,0.4-0.1,0.7v5.3h-1.6L179.2,9.2L179.2,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2042_",
    className: "st1",
    d: "M197.3,13.5c0,0.7,0,1.3,0.1,1.9h-1.4l-0.1-0.9h-0.1c-0.4,0.7-1.1,1-1.9,1 c-1.3,0-2.4-1-2.4-2.4c0-2.1,2-3,4.2-3V9.9c0-1.1-0.3-1.9-1.6-1.9c-0.6,0-1.2,0.1-1.6,0.4l-0.4-1c0.4-0.2,1.3-0.5,2.3-0.5 c2,0,2.8,1.1,2.8,3L197.3,13.5L197.3,13.5z M195.7,11.1c-0.8,0-2.7,0.1-2.7,1.9c0,1.1,0.7,1.5,1.2,1.5c0.7,0,1.3-0.4,1.5-1.3 c0.1-0.1,0.1-0.3,0.1-0.4V11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2039_",
    className: "st1",
    d: "M137.6,20.6c0.7-0.1,1.4-0.2,2.3-0.2c1.3,0,2.3,0.2,3,0.9c0.7,0.5,1,1.4,1,2.4 c0,1-0.3,1.8-0.8,2.4c-0.7,0.9-2,1.3-3.3,1.3c-0.3,0-0.4,0-0.7,0V32h-1.6L137.6,20.6L137.6,20.6z M139.2,26.2 c0.1,0,0.4,0.1,0.6,0.1c1.6,0,2.6-0.9,2.6-2.5c0-1.2-0.6-2.2-2.3-2.2c-0.4,0-0.7,0-0.9,0.1L139.2,26.2L139.2,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2036_",
    className: "st1",
    d: "M146.3,28c0,2.5,1.2,3.1,2.4,3.1c0.7,0,1.3-0.1,1.6-0.3l0.2,1c-0.5,0.2-1.4,0.4-2.2,0.4 c-2.4,0-3.6-1.6-3.6-4.2c0-2.7,1.3-4.4,3.3-4.4s2.8,1.8,2.8,3.7c0,0.3,0,0.5,0,0.7L146.3,28L146.3,28z M149.4,27 c0.1-1.7-0.7-2.4-1.5-2.4c-1,0-1.6,1.3-1.6,2.4H149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2033_",
    className: "st1",
    d: "M157.1,31.2L157.1,31.2c-0.4,0.6-1,1-1.9,1c-1.6,0-2.9-1.5-2.9-4.2c0-3,1.5-4.4,3.1-4.4 c0.7,0,1.3,0.2,1.9,1.1h0.1l0.1-1h1.4c-0.1,0.6-0.1,1.3-0.1,2.6v9h-1.6L157.1,31.2L157.1,31.2z M157.1,26.8 c0-0.1,0-0.4-0.1-0.5c-0.1-0.9-0.7-1.6-1.4-1.6c-1.3,0-1.8,1.5-1.8,3.2c0,1.8,0.5,3.2,1.7,3.2c0.5,0,1.1-0.2,1.4-1.4 c0.1-0.2,0.1-0.5,0.1-0.7L157.1,26.8L157.1,26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2032_",
    className: "st1",
    d: "M166.9,29.8c0,1,0.1,1.6,0.1,2.3h-1.3l-0.1-0.9h-0.1c-0.3,0.4-1,1-2.2,1 c-1.7,0-2.4-1.1-2.4-3.2v-5.3h1.6v5.1c0,1.3,0.2,2.3,1.3,2.3c0.9,0,1.3-0.7,1.4-1.1c0.1-0.2,0.1-0.5,0.1-0.7v-5.5h1.6 L166.9,29.8L166.9,29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2029_",
    className: "st1",
    d: "M170.3,28c0,2.5,1.2,3.1,2.4,3.1c0.7,0,1.3-0.1,1.6-0.3l0.2,1c-0.5,0.2-1.4,0.4-2.2,0.4 c-2.4,0-3.6-1.6-3.6-4.2c0-2.7,1.3-4.4,3.3-4.4s2.8,1.8,2.8,3.7c0,0.3,0,0.5,0,0.7L170.3,28L170.3,28z M173.4,27 c0.1-1.7-0.7-2.4-1.5-2.4c-1,0-1.6,1.3-1.6,2.4H173.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2026_",
    className: "st1",
    d: "M176.7,25.9c0-1-0.1-1.5-0.1-2.2h1.3l0.1,1h0.1c0.4-0.7,1.3-1.1,2.3-1.1 c1.3,0,2.4,0.9,2.4,2.9v5.6h-1.6v-5.4c0-1-0.2-2-1.3-2c-0.7,0-1.3,0.4-1.5,1.3c-0.1,0.2-0.1,0.4-0.1,0.7V32h-1.6L176.7,25.9 L176.7,25.9z M177.6,22.4c0-0.9,0.4-1.6,1.3-1.6c0.4,0,0.7,0.1,1,0.3c0.3,0.1,0.5,0.3,0.8,0.3c0.3,0,0.4-0.1,0.5-0.6h0.8 c0,1-0.4,1.6-1.3,1.6c-0.4,0-0.7-0.1-1-0.3c-0.3-0.1-0.5-0.3-0.7-0.3c-0.3,0-0.4,0.2-0.5,0.7H177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2023_",
    className: "st1",
    d: "M190.4,30.2c0,0.7,0,1.3,0.1,1.9H189l-0.1-0.9h-0.1c-0.4,0.7-1.1,1-1.9,1 c-1.3,0-2.4-1-2.4-2.4c0-2.1,2-3,4.2-3v-0.3c0-1.1-0.3-1.9-1.6-1.9c-0.6,0-1.2,0.1-1.6,0.4l-0.4-1c0.4-0.2,1.3-0.5,2.3-0.5 c2,0,2.8,1.1,2.8,3L190.4,30.2L190.4,30.2z M188.8,27.8c-0.8,0-2.7,0.1-2.7,1.9c0,1.1,0.7,1.5,1.2,1.5c0.7,0,1.3-0.4,1.5-1.3 c0.1-0.1,0.1-0.3,0.1-0.4V27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2022_",
    className: "st1",
    d: "M192.4,30.7c0.4,0.2,1,0.4,1.6,0.4c0.9,0,1.5-0.4,1.5-1.2c0-0.7-0.3-1-1.3-1.6 c-1.3-0.7-2-1.4-2-2.4c0-1.3,1.2-2.3,2.7-2.3c0.7,0,1.3,0.2,1.8,0.4l-0.4,1c-0.4-0.2-0.8-0.4-1.3-0.4c-0.9,0-1.3,0.5-1.3,1 c0,0.6,0.2,0.9,1.3,1.5c1.1,0.6,2.1,1.4,2.1,2.5c0,1.7-1.3,2.4-3,2.4c-0.7,0-1.6-0.2-1.9-0.5L192.4,30.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2019_",
    className: "st1",
    d: "M137.6,37.3c0.6-0.1,1.3-0.2,2.2-0.2c1.5,0,2.4,0.3,3.3,0.9c1,0.7,1.9,2.3,1.9,4.7 c0,2.7-0.7,4.1-1.6,4.9c-0.9,0.9-2.2,1.3-3.8,1.3c-0.7,0-1.3,0-1.8-0.1L137.6,37.3L137.6,37.3z M139.2,47.7c0.2,0,0.4,0,0.6,0 c1.7,0,3.4-1,3.4-5c0-3-1-4.5-3.3-4.5c-0.2,0-0.5,0-0.7,0.1V47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2016_",
    className: "st1",
    d: "M152.9,44.5c0,3.2-1.8,4.3-3.3,4.3c-1.8,0-3.2-1.3-3.2-4.3c0-3,1.6-4.3,3.3-4.3 S152.9,41.6,152.9,44.5z M148,44.5c0,1.4,0.3,3.3,1.7,3.3c1.3,0,1.6-1.9,1.6-3.3c0-1.3-0.3-3.3-1.6-3.3 C148.2,41.3,148,43.3,148,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2015_",
    className: "st1",
    d: "M154.8,42.5c0-1-0.1-1.5-0.1-2.2h1.3l0.1,1h0.1c0.4-0.7,1.3-1.1,2.3-1.1 c1.3,0,2.4,0.9,2.4,2.9v5.6h-1.6v-5.4c0-1-0.2-2-1.3-2c-0.7,0-1.3,0.4-1.5,1.3c-0.1,0.2-0.1,0.4-0.1,0.7v5.3h-1.6L154.8,42.5 L154.8,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2012_",
    className: "st1",
    d: "M168.3,46.8c0,0.7,0,1.3,0.1,1.9H167l-0.1-0.9h-0.1c-0.4,0.7-1.1,1-1.9,1 c-1.3,0-2.4-1-2.4-2.4c0-2.1,2-3,4.2-3v-0.2c0-1.1-0.3-1.9-1.6-1.9c-0.6,0-1.2,0.1-1.6,0.4l-0.4-1c0.4-0.2,1.3-0.5,2.3-0.5 c2,0,2.8,1.1,2.8,3L168.3,46.8L168.3,46.8z M166.8,44.5c-0.8,0-2.7,0.1-2.7,1.9c0,1.1,0.7,1.5,1.2,1.5c0.7,0,1.3-0.4,1.5-1.3 c0.1-0.1,0.1-0.3,0.1-0.4V44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2011_",
    className: "st1",
    d: "M175.5,48.5c-0.4,0.1-1,0.3-1.6,0.3c-2.2,0-3.6-1.5-3.6-4.2c0-2.4,1.4-4.4,3.9-4.4 c0.5,0,1.1,0.1,1.4,0.2l-0.3,1.1c-0.2-0.1-0.6-0.2-1.1-0.2c-1.6,0-2.3,1.6-2.3,3.2c0,1.9,0.9,3.1,2.3,3.1 c0.4,0,0.7-0.1,1.1-0.2L175.5,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2008_",
    className: "st1",
    d: "M178.6,38.2c0,0.5-0.4,0.9-1,0.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9 C178.3,37.4,178.6,37.7,178.6,38.2z M176.9,48.8v-8.4h1.6v8.4H176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2005_",
    className: "st1",
    d: "M186.9,44.5c0,3.2-1.8,4.3-3.3,4.3c-1.8,0-3.2-1.3-3.2-4.3c0-3,1.6-4.3,3.3-4.3 S186.9,41.6,186.9,44.5z M182,44.5c0,1.4,0.3,3.3,1.7,3.3c1.3,0,1.6-1.9,1.6-3.3c0-1.3-0.3-3.3-1.6-3.3 C182.2,41.3,182,43.3,182,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2004_",
    className: "st1",
    d: "M188.7,42.5c0-1-0.1-1.5-0.1-2.2h1.3l0.1,1h0.1c0.4-0.7,1.3-1.1,2.3-1.1 c1.3,0,2.4,0.9,2.4,2.9v5.6h-1.6v-5.4c0-1-0.2-2-1.3-2c-0.7,0-1.3,0.4-1.5,1.3c-0.1,0.2-0.1,0.4-0.1,0.7v5.3h-1.6L188.7,42.5 L188.7,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2001_",
    className: "st1",
    d: "M198.2,44.7c0,2.5,1.2,3.1,2.4,3.1c0.7,0,1.3-0.1,1.6-0.3l0.2,1 c-0.5,0.2-1.4,0.4-2.2,0.4c-2.4,0-3.6-1.6-3.6-4.2c0-2.7,1.3-4.4,3.3-4.4c2,0,2.8,1.8,2.8,3.7c0,0.3,0,0.5,0,0.7L198.2,44.7 L198.2,44.7z M201.3,43.7c0.1-1.7-0.7-2.4-1.5-2.4c-1,0-1.6,1.3-1.6,2.4H201.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2000_",
    className: "st1",
    d: "M204.4,47.4c0.4,0.2,1,0.4,1.6,0.4c0.9,0,1.5-0.4,1.5-1.2c0-0.7-0.3-1-1.3-1.6 c-1.3-0.7-2-1.4-2-2.4c0-1.3,1.2-2.3,2.7-2.3c0.7,0,1.3,0.2,1.8,0.4l-0.4,1c-0.4-0.2-0.8-0.4-1.3-0.4c-0.9,0-1.3,0.5-1.3,1 c0,0.6,0.2,0.9,1.3,1.5c1.1,0.6,2.1,1.4,2.1,2.5c0,1.7-1.3,2.4-3,2.4c-0.7,0-1.6-0.2-1.9-0.5L204.4,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1997_",
    className: "st1",
    d: "M143.4,53.5v9.9c0,0.6,0.1,1.5,0.1,2h-1.3l-0.1-1H142c-0.3,0.6-1,1.2-2.1,1.2 c-1.7,0-2.9-1.6-2.9-4.3c0-3,1.5-4.4,3-4.4c0.7,0,1.4,0.3,1.8,1h0.1v-4.4L143.4,53.5L143.4,53.5z M141.9,60.3 c0-0.1,0-0.4,0-0.5c-0.1-0.9-0.7-1.6-1.5-1.6c-1.3,0-1.8,1.6-1.8,3.2c0,1.8,0.5,3.2,1.7,3.2c0.5,0,1.2-0.2,1.5-1.4 c0.1-0.1,0.1-0.4,0.1-0.5V60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1994_",
    className: "st1",
    d: "M146.8,61.4c0,2.5,1.2,3.1,2.4,3.1c0.7,0,1.3-0.1,1.6-0.3l0.2,1 c-0.5,0.2-1.4,0.4-2.2,0.4c-2.4,0-3.6-1.6-3.6-4.2c0-2.7,1.3-4.4,3.3-4.4c2,0,2.8,1.8,2.8,3.7c0,0.3,0,0.5,0,0.7L146.8,61.4 L146.8,61.4z M149.9,60.4c0.1-1.7-0.7-2.4-1.5-2.4c-1,0-1.6,1.3-1.6,2.4H149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1993_",
    className: "st1",
    d: "M153.3,53.5h1.6v11.9h-1.6V53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1992_",
    className: "st1",
    d: "M160.7,53.8h5.3V55h-3.7v4.1h3.4v1.1h-3.4v5.3h-1.6V53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1991_",
    className: "st1",
    d: "M176,60.4c-0.1-1.6-0.2-3.3-0.1-4.5h-0.1c-0.3,1.3-0.7,2.7-1.1,4l-1.7,5.4h-1l-1.6-5.2 c-0.4-1.5-0.9-2.9-1.1-4.2h-0.1c0,1.3-0.1,3-0.1,4.7l-0.3,4.9h-1.4l0.8-11.6h1.7l1.6,5.3c0.4,1.6,0.8,2.7,1.1,4h0.1 c0.3-1.3,0.6-2.4,1-4l1.6-5.3h1.8l0.8,11.6h-1.5L176,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_197_",
    className: "st1",
    d: "M181.5,62l-0.9,3.5h-1.5l3.1-11.6h1.7l3,11.6h-1.6l-0.9-3.5H181.5z M184.3,60.9l-0.7-3 c-0.2-0.8-0.4-1.8-0.5-2.7H183c-0.1,0.9-0.4,1.9-0.5,2.7l-0.7,3H184.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_196_",
    className: "st1",
    d: "M197,60.4c-0.1-1.6-0.2-3.3-0.1-4.5h-0.1c-0.3,1.3-0.7,2.7-1.1,4l-1.7,5.4h-1l-1.6-5.2 c-0.4-1.5-0.9-2.9-1.1-4.2h-0.1c0,1.3-0.1,3-0.1,4.7l-0.3,4.9h-1.4l0.8-11.6h1.7l1.6,5.3c0.4,1.6,0.8,2.7,1.1,4h0.1 c0.3-1.3,0.6-2.4,1-4l1.6-5.3h1.8l0.8,11.6h-1.5L197,60.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_184_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_192_",
    className: "st1",
    d: "M74.8,8.1C71.3,4.8,65.8,3,58.4,3c-6.1,0-10.9,0.5-14.5,1.2v61.2h7.6V40.6 c1.7,0.4,3.9,0.5,6.1,0.5c7.4,0,13.9-2.3,17.9-6.8c3-3.2,4.5-7.6,4.5-13.2C79.9,15.6,77.9,11.1,74.8,8.1z M57.6,34.7 c-2.5,0-4.6-0.1-6.3-0.7V10c1.3-0.4,3.9-0.7,7.1-0.7c8.3,0,13.9,3.9,13.9,12.2C72.4,29.9,66.8,34.7,57.6,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_189_",
    className: "st1",
    d: "M34.3,8.1C30.8,4.8,25.3,3,17.8,3C11.7,3,6.9,3.5,3.3,4.2v61.2h7.6V40.6 c1.7,0.4,3.9,0.5,6.1,0.5c7.4,0,13.9-2.3,17.9-6.8c3-3.2,4.5-7.6,4.5-13.2C39.4,15.6,37.4,11.1,34.3,8.1z M17.1,34.7 c-2.5,0-4.6-0.1-6.3-0.7V10c1.3-0.4,3.9-0.7,7.1-0.7c8.3,0,13.9,3.9,13.9,12.2C31.8,29.9,26.2,34.7,17.1,34.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_185_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_186_",
    className: "st1",
    d: "M83.9,4.1c4.5-0.8,9.9-1.4,15.9-1.4c10.8,0,18.4,2.7,23.4,7.8c5.3,5,8.2,12.2,8.2,22.3 c0,10.2-3,18.5-8.3,24.2c-5.5,5.8-14.5,9-25.7,9c-5.4,0-9.8-0.3-13.6-0.7L83.9,4.1L83.9,4.1z M91.4,59.1 c1.9,0.3,4.7,0.4,7.6,0.4c16.1,0,24.6-9.6,24.6-26.4c0.1-14.7-7.6-24-23.4-24c-3.9,0-6.8,0.4-8.8,0.8L91.4,59.1L91.4,59.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_156_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_179_",
    className: "st1",
    d: "M242.2,66.5L225.1,3.4h9.1l7.3,29.6c1.8,7.1,4,16.2,5.3,24.3h0.3c1.1-8.1,3.2-17,5-24.4 l7.1-29.4h9.1L251,66.5H242.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_177_",
    className: "st1",
    d: "M305.2,36.6h-18.8v23.7h21.3v6.3h-29.9V3.4h28.5v6.3h-20v20.8h18.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    className: "st1",
    d: "M318.3,66.5V3.4h8.1L340.2,33c3.1,6.7,7,15.2,9.5,22h0.2c-0.7-9.9-1-18.1-1-29V3.4h7.7 v63.1h-8.1l-14.2-30.3c-3-6.4-6.2-13.6-8.9-21.5h-0.2c0.7,8.4,0.9,16.5,0.9,30v21.8H318.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    className: "st1",
    d: "M398.4,36.6h-18.8v23.7h21.3v6.3h-29.9V3.4h28.5v6.3h-20v20.8h18.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_170_",
    className: "st1",
    d: "M407,62.2l25.7-52.4V9.6h-23.5V3.4h33.1v4.9L417,60.1v0.3h25.1v6.2H407V62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_168_",
    className: "st1",
    d: "M460.8,3.4v42.3c0,11.3,4.4,15.2,10.2,15.2c6.3,0,10.3-4.1,10.3-15.2V3.4h8.6v41.2 c0,16.4-8,22.7-19.1,22.7c-11.2,0-18.5-6.2-18.5-21.8V3.4H460.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_164_",
    className: "st1",
    d: "M531.5,36.6h-18.8v23.7h21.3v6.3h-29.9V3.4h28.5v6.3h-20v20.8h18.8V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    className: "st1",
    d: "M544.6,3.4h8.6v57h21.1v6.1h-29.7V3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_158_",
    className: "st1",
    d: "M593.3,47.6l-5,18.9H580l17.1-63.1h9.4l16.7,63.1h-8.4l-5-18.9H593.3z M608.7,41.8l-3.9-16 c-1.1-4.5-2.1-9.7-3-14.4h-0.4c-0.9,4.8-2,10.2-3,14.4l-3.9,16H608.7z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpdVzlaUpdates);
export default __webpack_public_path__ + "static/media/ppdVzlaUpdates.7a6fd2dd13fe3f6de777cb9554a583b8.svg";
export { ForwardRef as ReactComponent };